
export function setAccountsFrom(state, accounts_from) {
    state.accounts_from = accounts_from
}

export function setAccountsUp(state, accounts_up) {
    state.accounts_up = accounts_up
}

export function settrial_balance(state, trial_balance) {
    state.trial_balance = trial_balance
}
export function setParams(state, params){
    state.params = params
}

export function setLevels (state, levels){
  state.levels = levels
}



// WEBPACK FOOTER //
// ./src/modules/nuevo-informe/mutations.js